import { Component, OnInit, ViewContainerRef, TemplateRef } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import { Payment } from '../../models/payment/payment-model';
import { PaymentService } from '../../services/payment/payment.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { MediaLibraryService } from '../../services/mediaLibrary/media-library.service';
import { MediaLibrary } from '../../models/mediaLibrary/media-library-model';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ProfileService } from '../../services/profile/profile.service';
import { RolePermissionService } from '../../services/role/role-permission.service';

@Component({
  selector: 'app-edit-payment-method',
  templateUrl: './edit-payment-method.component.html',
  styleUrls: ['./edit-payment-method.component.css']
})
/** edit-payment-method component*/
export class EditPaymentMethodComponent {
  payment = new Payment();
  fileToUpload: File;
  fd = new FormData();
  selectedPaymentLogo: string;
  editPaymentLogo: string;
  validate: boolean;
  userId: number;
  mediaImageShow: boolean;
  public mediaList: MediaLibrary[];
  modalRef: BsModalRef;
  config = {
    animated: true
  };
  constructor(private _avRoute: ActivatedRoute,
    private paymentService: PaymentService, private _router: Router, public toastr: ToastsManager, vcr: ViewContainerRef,
    private readonly profileService: ProfileService, private readonly mediaServices: MediaLibraryService, private modalService: BsModalService,
    private readonly rolePermissionService: RolePermissionService) {
    this.rolePermissionService.GetRolePermissions("paymentmethod").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (create.length > 0) {
            if (this._avRoute.snapshot.params["id"]) {
              this.getPaymentMethodById(this._avRoute.snapshot.params["id"]);
              this.toastr.setRootViewContainerRef(vcr);
            }
            this.profileService.getProfile().subscribe(
              data => {
                if (data) {
                  this.userId = data.userID;
                }
                else {
                  this.userId = 0;
                }
              });
            this.validate = true;

          }
          else {
            this._router.navigate(["/payment-list"]);
          }
        }
        else {
          this._router.navigate(["/payment-list"]);
        }
      }
    )
  }
  getPaymentMethodById(id: string) {
    this.paymentService.getPaymentMethodById(id).subscribe(
      data => {
        this.payment = data;
      }
    )
  }
  SlectImage(Image: MediaLibrary) {
    this.fileToUpload = null;
    this.fd = new FormData();
    this.editPaymentLogo = Image.fileName;
    this.mediaList.forEach(x => {
      x.activeDiv = false;
    });


    Image.activeDiv = !Image.activeDiv;
  }
  HidePopup() {
    this.editPaymentLogo="";
    this.modalRef.hide();
  }
  ShowImage() {
    this.selectedPaymentLogo = "";
    this.payment.paymentLogo = this.editPaymentLogo;
    this.modalRef.hide();
  }
  OpenMediaPopup(template: TemplateRef<any>, ImageFor: string) {
    this.mediaServices.getMediaLibraryFor(ImageFor).subscribe(
      data => {
        this.mediaList = data;
        if (this.mediaList.length > 0) {
          this.modalRef = this.modalService.show(template, { class: 'modal-lg' });
        }

      }
    )
  }
  uploadPaymentLogo(file: FileList) {
    this.selectedPaymentLogo = "";
    this.fileToUpload = file.item(0);
    this.fd.append("PaymentLogo", this.fileToUpload);
    ////Show image preview
    var reader = new FileReader();
    reader.onload = (event: any) => {
      this.payment.paymentLogo = "";
      this.mediaImageShow = true;
      this.selectedPaymentLogo = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
  }
  isActiveCheckbox(event : any)
  {
    
  }
  isDefualtCheckbox(event: any) {
    
  }
  onSubmit() {
    this.validate = false;
    this.paymentService.updatePaymentMethod(this.payment).subscribe(result => {
      if (result) {
        this.toastr.success('Payment Method has been Updated. ', 'Success');
        this.fd.append("PaymentID", this.payment.paymentID.toString());
        this.paymentService.AddPaymentLogo(this.fd,this.userId);
      }
      else {
        this.toastr.error('Error occurred. Please try again', 'Error');
      }
    });
  }
}




// WEBPACK FOOTER //
// ./src/app/payment-components/edit-payment-method/edit-payment-method.component.ts